/**
 * Dump last N entries of call stack at given position in a short format
 *
 * Useful to inspect where are heavily used functions called from.
 * Error to get the stack is created outside and passed to this function.
 * Example:
 * ```
 * function render() {
 *   if (someDebugFlag) {
 *     dumpCallStackTop(new Error(), 'render');
 *   }
 * }
 * ```
 */
export const dumpCallStackTop = (
  extractStackFrom: Error,
  label: string,
  firstEntry = 1, // skip first row by default as it is usually the inspected function itself
  numEntries = 3,
): void => {
  if (process.env.NODE_ENV === 'development') {
    // biome-ignore lint/suspicious/noConsole: development debug tool
    console.log(
      label,
      // this should filter file name and line
      Array.from((extractStackFrom as any).stack.matchAll(/\s*at.*?([^/]*)\)/g))
        .slice(firstEntry, numEntries + firstEntry)
        .map((x) => (x as any)[1])
        .join('<'),
    );
  }
};
